import React, { Component } from "react";
import {
  StyleSheet,
  Text,
  View,
  ImageBackground,
  TextInput,
  StatusBar,
  SafeAreaView,
  ScrollView,
  TouchableOpacity,
  ActivityIndicator,
  Platform,
} from "react-native";
import {
  PostList,
  Flex,
  Padding,
  Margin,
  Helpers,
  Typo,
  appStyles,
  postSingle,
  FontFamily,
  FontWeight,
  pageCover,
  button,
  Colors,
} from "../../styles/appStyles";
import ReactHtmlParser from 'react-html-parser';
import { helpers } from "../../utils/helpers";
// import LinearGradient from 'react-native-web-linear-gradient';
import apiHelpers from "../../utils/api-helpers";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ErrorModal from "../../components/error-modal";
import { removeUserToken } from "../../../redux/User/user.actions";
import AppHeader from "../../components/app-header";
import AppFooter from "../../components/app-footer";
import CustomImage from "../../components/custom-image";
import Seo from "../../components/seo-meta";
import seoObj from "../../utils/seo-helper";
import WhyYesterDay from "../../components/why-yesterday";
import getImagePath from "../../utils/image-helper";
import moment from "moment";
// const LinearGradient = React.lazy(() => (Platform.OS == 'web') ? import('react-native-web-linear-gradient') : import('react-native-linear-gradient'));
import truncate from'truncate-html'

const yesterdayBG = getImagePath("img/yesterdayBG.png");

const yesterdayImage2 = getImagePath("img/yesterdayImage2.png");
const yesterdayImageDesktop3 = getImagePath("img/yesterdayImageDesktop3.png");
const yesterdayImageMobile3 = getImagePath("img/yesterdayImageMobile3.png");

const NotificationsFlatline = getImagePath("img/NotificationsFlatline.png");
const notificationsFlatlineMobile = getImagePath(
  "img/notificationsFlatlineMobile.png"
);

const business = getImagePath('icons/business.png');
const covid = getImagePath('icons/covid-19.png');
const envoroment = getImagePath('icons/envoroment.png');
const markets = getImagePath('icons/markets.png');
const sports = getImagePath('icons/sports.png');
const world = getImagePath('icons/world.png');
const economy = getImagePath('icons/economy.png');
const choas = getImagePath('icons/choas.png');
const politics = getImagePath('icons/politics.png');
const accountContentBoxbg = getImagePath("img/accountItemBg.png");
const rightArrow = getImagePath("icons/rightArrow.png");
const healthcare = getImagePath("icons/healthcare.png");
const yesterdayLogo = getImagePath("icons/yesterdayLogo.png");
const arrowDownYesterdayIcon = getImagePath("icons/arrowDownYesterdayIcon.png");

import YesterdayStoryBanner from "../../components/yesterday-story-banner";
import SmartReaders from "../../components/smart-readers";
import ButtonGradient from "../../components/button-gradient";
import YesterdayHomeSection from "../../components/yesterday-home-section";
import AuthenticationWrapper from "../../components/authentication-wrapper";
import PostContent from "../../components/post-content";

export class Yesterday extends Component {
  constructor(props) {
    super(props);
    let webView = helpers.isWeb();  
    const { isAuthenticated, fetchToken } = this.props.auth;
    let token = webView
      ? process.browser
        ? isAuthenticated
          ? fetchToken
          : false
        : this.props.token
      : this.props.user?.userData?.data?.token;

    this.state = {
      pageLoader: false,
      storyData: [],
      showErrorModal: false,
      showUparrow: false,
      footerData: this.props.footerData ? this.props.footerData : false,
      isUserLoggedIn: token == undefined || token == "" ? false : true,
      token: token == undefined || token == "" ? false : token,
      storyDataLastWeek:[],
      selectedTab:1
    };
  }

  componentDidMount = () => {
    this.getEditions();
    /**
     * for loggied user: second API call for Explore previous Yesterday editions 
     * default call for last 7 days data
     */
     if(this.state.token){
       let currentDate = new Date()
          let endDate = new Date(currentDate);
            let startDate = undefined;
          // if the current date is the beginning of the week then do not consider end_date
          if(endDate.getDay() === 0){
            currentDate.setDate(currentDate.getDate()-1);
        }
        else{
            startDate = moment(new Date()).subtract(7, 'days').format("DD-MM-YYYY")
        }
        this.getEditions(
          startDate,
          moment(endDate).format("DD-MM-YYYY")
        );
        
      }
  };

  getEditions = (start_date,end_date) => {
    // console.log('yogi',moment(new Date()).subtract(1, 'days').format("DD-MM-YYYY"));

    const { token,isUserLoggedIn } = this.state;
        let endpoint = `/yesterday/editions`;
        let body={}
        if(start_date){
           body = {
            "sort_on": "published_date",
            "sort_by": "DESC",
            start_date:start_date,
            end_date:end_date
          }
        }else{

           body = {
            "sort_on": "DESC",
            "sort_by": "published_date",
            // "published_date": moment(new Date()).format("DD-MM-YYYY"),            
            start_date: moment(new Date()).subtract(30, 'days').format("DD-MM-YYYY"),            
            end_date: moment(new Date()).format("DD-MM-YYYY"),
            limit : 1

          }
        }
        apiHelpers
            .apiRequest(endpoint,body, "POST", true, token)
            .then((res) => {
              // for storying all data
              if(start_date){
                this.setState({
                  storyDataLastWeek:res.data.editions
              })
              }else{

                this.setState({
                  storyData:res.data.editions[0]
                })
              }
            })
            .catch((error) => {
              this.setState({
                storyDataLastWeek:error.ok,
              })
                console.log('Error=>> down', JSON.stringify(error));
            });
  };

  renderPageHeader = () => {
    let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);
    return (
      <YesterdayHomeSection
        darkMode={darkMode}
        isUserLoggedIn={this.state.isUserLoggedIn}
        navigateWeb={(slug) => this.props.navigateToScreen(slug)}
        navigateApp={(slug, params) =>
          this.props.navigation.navigate(slug, params)
        }
      />
    );
  };

  showPageLoader = () => {
    const webView = helpers.isWeb();
    return (
      <View
        style={[
          Flex.justfiyCenter,
          Flex.alignCenter,
          {
            position: webView ? "fixed" : "absolute",
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            backgroundColor: "#ffffff",
          },
        ]}
      >
        <ActivityIndicator size={25} color={"#000000"} />
      </View>
    );
  };

  categoryImage=(category)=>{
    let image 
    if(category ==='Health')
       return image=healthcare
    if(category === "Business")
       return image =business
    if(category === "Choas")
        return image =Chaos
    if(category ==='Covid-19')
       return image=covid
    if(category === "Ecomony" || category === "Nation" )
       return image =economy
    if(category === "Markets")
        return image =markets
    if(category ==='Sports')
        return image=healthcare
    if(category === "World")
        return image =world
    if(category === "politics")
    return image =politics
}
renderBorderColor=(colorVal)=>{
  let color 
    if(colorVal ==='Health')
       return color='#ECB731'
    if(colorVal === "Business")
       return color ='#A97DF1'
    if(colorVal === "Choas")
        return color ="#55C79A"
    if(colorVal ==='Covid-19')
       return color='#EC3131'
    if(colorVal === "Ecomony" || colorVal === "Nation" )
       return color ="#31BFEC"
    if(colorVal === "Markets")
        return color ="#EC31C3"
    if(colorVal ==='Sports')
        return color="#5DC5BE"
    if(colorVal === "World")
        return color ="#3531EC"
    if(colorVal === "politics")
    return color ="#DE0046"
}


  YesterdayData = (darkMode) => {
    let { isUserLoggedIn,storyData ,storyDataLastWeek,selectedTab} = this.state;
    return (
      <View>
        {storyData?.published_date ?
        <View
          style={[
            helpers.isDesktop() && {
              backgroundColor: isUserLoggedIn ? "#F3F5FF" : "#ffffff",
            },
            {
              padding: helpers.isDesktop() ? 40 : 16,
              paddingBottom: helpers.isDesktop() ? 0 : 40,
            },
            darkMode && { backgroundColor: Colors.darkPurple },
          ]}
        >
          <View
            style={[
              helpers.isDesktop() && {
                backgroundColor: isUserLoggedIn ? "#ffffff" : "#ffffff",
              },
              {
                padding: isUserLoggedIn ? (helpers.isDesktop() ? 20 : 16) : 0,
                maxWidth: helpers.isDesktop() ? "70%" : "100%",
                width: "100%",
                margin: "auto",
              },
            ]}
          >
            {isUserLoggedIn ? (
              <Text
                style={[
                  {
                    fontSize: helpers.isDesktop() ? 36 : 22,
                    lineHeight: helpers.isDesktop() ? 39.6 : 32.56,
                    fontFamily: FontFamily.bold,
                    color: "#051462",
                    fontWeight: "600",
                  },
                  { paddingBottom: 2, textAlign: "left" },
                  darkMode && { color: "rgba(255, 255, 255, 0.89)" },
                ]}
              >
                {" "}
                {moment(storyData?.published_date).format('DD MMMM YYYY')}
              </Text>
            ) : (
              <Text
                style={[
                  {
                    fontSize: helpers.isDesktop() ? 24 : 16,
                    lineHeight: helpers.isDesktop() ? 35.5 : 23,
                    fontFamily: FontFamily.medium,
                    color: "rgba(5, 20, 98, 0.4)",
                  },
                  { paddingBottom: 3, textAlign: "left" },
                  darkMode && { color: "rgba(255, 255, 255, 0.89)" },
                ]}
              >
                {moment(storyData?.published_date).format('DD MMMM YYYY')}
              </Text>
            )}
            {!isUserLoggedIn && (
              <View
                style={[
                  {
                    width: helpers.isDesktop() ? 392 : 221,
                    marginBottom: 30,
                  },
                ]}
              >
                <CustomImage
                  resizeMode={"contain"}
                  source={yesterdayLogo}
                  require={true}
                  style={[
                    helpers.isWeb()
                      ? {
                          width: helpers.isDesktop() ? 116 : 80,
                          aspectRatio: 1 / 10,
                        }
                      : { width: 200, height: 20, backgroundColor: "yellow" },
                  ]}
                  webStyle={{
                    width: helpers.isDesktop() ? 344 : 195,
                    height: helpers.isDesktop() ? "auto" : 26,
                  }}
                  altText={"Yesterday Logo"}
                />
              </View>
            )}
            
             { storyData && storyData.posts && storyData.posts.map((item,index)=>{
               return(
                <View
              style={[
                { backgroundColor: isUserLoggedIn ? "white" : "#F3F5FF" },
                !isUserLoggedIn && {
                  marginBottom: 30,
                  borderLeftWidth: helpers.isDesktop() ? 8 : 3,
                  borderColor: this.renderBorderColor(item?.category[0]),
                  // borderColor: "#ECB731",
                },
                {
                  padding: helpers.isDesktop() ? 20 : 16,
                  paddingRight: helpers.isDesktop() ? 20 : 8,
                },
                darkMode && { backgroundColor: Colors.darkPurple },
              ]}
            >
                <View
                style={[
                  {  marginBottom: 15,
                  
                    height: helpers.isDesktop() ? 32 : 40, },
                ]}
              >
                {item.category.map((value,index)=>{
                  return(
                <CustomImage
                source={this.categoryImage(value)}
                  require={true}
                  style={[
                    helpers.isWeb()
                      ? {
                          width:  "fit-content",
                          height: 32,
                        }
                      : {
                        width:  "fit-content",
                          height: helpers.isDesktop() ? 32 : 20,
                        },
                  ]}
                  webStyle={{
                    width:  "fit-content",
                    height: helpers.isDesktop() ? 32 : 36,
                  }}
                  altText={"The Morning Context"}
                />
                )
              }) 
              }
              </View>
              <View
                style={[
                  isUserLoggedIn && {
                    marginBottom: 30,
                    borderLeftWidth: 8,
                    // borderColor: "#ECB731",
                  borderColor: this.renderBorderColor(item?.category[0]),
                    paddingLeft: 10,
                  },
                ]}
              >
                <TouchableOpacity
                    onPress={() =>
                      this.props.navigateToScreen(`/yesterday/${storyData?.slug}`)
                    }>
                <Text
                  style={[
                    {
                      fontSize: helpers.isDesktop() ? 24 : 18,
                      lineHeight: helpers.isDesktop() ? 34 : 26,
                      fontFamily: FontFamily.bold,
                      color: "#051462",
                    },
                    { paddingBottom: 3, textAlign: "left" },
                    darkMode && { color: "rgba(255, 255, 255, 0.89)" },
                  ]}
                >
                  {item.title}
                </Text>
                <Text
                  style={[
                    {
                      fontSize: helpers.isDesktop() ? 18 : 16,
                      lineHeight: helpers.isDesktop() ? 36 : 23,
                      fontFamily: FontFamily.regular,
                      // marginTop: helpers.isDesktop() ? 16 : 8,
                      color: "#051462",
                    },
                    { paddingBottom: 3, textAlign: "left" },
                    darkMode && { color: "rgba(255, 255, 255, 0.89)" },
                  ]
                }
                >
                  {/* <PostContent data={truncate(item.content, 50, { byWords: true })} darkMode={darkMode} openLink={(link) => this.openSocialMedia(link)} /> */}
                    {/* {ReactHtmlParser(truncate(item.content, 50, { byWords: true }))} */}
                    <View className={"postsingle-content postsingle-bodyfont"}>{ 
                    ReactHtmlParser(truncate(item.content, 50, { byWords: true }))
                    }</View>
                    {/* {console.log('content',truncate(item.content, 50, { byWords: true }))}
                    {console.log('content ori',item.content)} */}


                  
                  

                </Text>
                </TouchableOpacity>
                {!isUserLoggedIn ? (
                  <TouchableOpacity
                    onPress={() =>
                      this.props.navigateToScreen(`/yesterday/${storyData?.slug}`)
                    }
                    style={[
                      Flex.row,
                      Flex.alignCenter,
                      !helpers.isDesktop() && { marginTop: 16 },
                    ]}
                  >
                    <Text
                      style={[
                        {
                          fontSize: helpers.isDesktop() ? 18 : 15,
                          lineHeight: helpers.isDesktop() ? 26 : 22,
                          fontFamily: FontFamily.bold,
                          color: "#907CFF",
                          marginVertical: 16,
                        },
                        {
                          textAlign: "left",
                          paddingRight: 10,
                        },
                        darkMode && { color: "rgba(255, 255, 255, 0.89)" },
                      ]}
                    >
                      LEARN MORE
                    </Text>
                    <View>
                      <CustomImage
                        source={rightArrow}
                        require={true}
                        resizeMode={"contain"}
                        style={[{ width: 14.8, height: 18 }]}
                        altText={"The Morning Context"}
                      />
                    </View>
                  </TouchableOpacity>
                ) : null}
              </View>
              </View>

               )
             })
              }

            <View style={[{ paddingVertical: 20 }]}>
              <ButtonGradient
                title={
                  isUserLoggedIn
                    ? helpers.isDesktop()
                      ? "Take me to Yesterday"
                      : "Take me to Yesterday"
                    : "Read more from Yesterday"
                }
                rootStyle={{
                  btnWrapper: [button.primaryGradient, { width: "100%" }],
                  btnText: [
                    button.primaryGradientText,
                    { fontSize: 16, fontWeight: "600" },
                  ],
                }}
                onClick={() =>
                  this.props.navigateToScreen(`/yesterday/${storyData?.slug}`)
                }
                darkMode={darkMode}
              />
            </View>
          </View>
        </View>:
          <View style={[styles.container]}>
            <ActivityIndicator size="large" style = {styles.activityIndicator}/>          
          </View>
        }

        {/*  Explore previous Yesterday editions section */}
        <View
          style={[
            { backgroundColor: isUserLoggedIn ? "#F3F5FF" : "#ffffff" },
            { padding: helpers.isDesktop() ? 40 : 30, paddingTop: 0 },
            darkMode && { backgroundColor: Colors.darkPurple },
          ]}
        >
          {isUserLoggedIn && (
            <View
              style={[
                {
                  maxWidth: helpers.isDesktop() ? "70%" : "100%",
                  width: "100%",
                  margin: "auto",
                  paddingTop: helpers.isDesktop() ? 30 : 20,
                },
              ]}
            >
              <View>
                <Text
                  style={[
                    {
                      fontSize: helpers.isDesktop() ? 36 : 22,
                      lineHeight: helpers.isDesktop() ? 39.6 : 32.56,
                      fontFamily:  FontFamily.bold,
                      color: "#051462",
                    },
                    { marginBottom: 15, marginTop: 15, textAlign: "left" },
                    darkMode && { color: "rgba(255, 255, 255, 0.89)" },
                  ]}
                >
                  Explore previous {!helpers.isDesktop() && "\n"}
                   Yesterday editions
                </Text>
                <SafeAreaView style={customStyle.container}>
                  <ScrollView horizontal={true} style={customStyle.scrollView}>
                    <View style={[Flex.row, { marginBottom: 15 }]}>
                      {/* <LinearGradient
                                                start={{ x: 0, y: 0 }} end={{ x: 1, y: 0 }}
                                                colors={['#6C7AF6', '#A97DF1']}
                                                style={[Flex.row, Flex.alignCenter, Flex.justfiyCenter, { marginRight: 10, marginBottom: 15, width: helpers.isDesktop() ? 93 : 111 }, { padding: 8, borderRadius: 20, borderColor: "#7B8FFE", backgroundColor: "linear-gradient(90.97deg, #6C7AF7 0%, #A97DF1 99.9%)", borderWidth: 2, }]}
                                            >
                                                <Text style={[{ fontSize: helpers.isDesktop() ? 14 : 16, lineHeight: helpers.isDesktop() ? 16 : 23, fontFamily: FontFamily.regular, color: "#ffffff" }]}>Last Week</Text>
                                            </LinearGradient> */}
                      <TouchableOpacity
                       onPress={()=>{
                        this.componentDidMount();
                        this.setState({selectedTab:1})
                       }}
                        style={[
                          Flex.row,
                          Flex.alignCenter,
                          Flex.justfiyCenter,
                          {
                            marginRight: 10,
                            marginBottom: 15,
                            width: helpers.isDesktop() ? 93 : 111,
                          },
                          {
                            padding: 8,
                            borderRadius: 20,
                            borderColor: "#7B8FFE",
                            background: selectedTab ==1 ? "#7B8FFE":'#ffffff',
                            borderWidth: 2,
                          },
                        ]}
                      >
                        <Text
                          style={[
                            {
                              fontSize: helpers.isDesktop() ? 14 : 16,
                              lineHeight: helpers.isDesktop() ? 16 : 23,
                              fontFamily: FontFamily.regular,
                              color: selectedTab ==1 ? '#ffffff':"#7B8FFE",
                            },
                          ]}
                        >
                          Last Week
                        </Text>
                      </TouchableOpacity>
                      <TouchableOpacity
                      onPress={()=>{
                       this.getEditions(
                          moment(new Date()).subtract(14, 'days').format("DD-MM-YYYY"),
                          moment(new Date()).subtract(8, 'days').format("DD-MM-YYYY"),

                        );
                        this.setState({selectedTab:2})

                      }}
                        style={[
                          Flex.row,
                          Flex.alignCenter,
                          Flex.justfiyCenter,
                          {
                            marginRight: 10,
                            marginBottom: 15,
                            width: helpers.isDesktop() ? 93 : 111,
                          },
                          {
                            padding: 8,
                            borderRadius: 20,
                            borderColor: "#7B8FFE",
                            background: selectedTab ==2 ? "#7B8FFE":'#ffffff',
                            borderWidth: 2,
                          },
                        ]}
                      >
                        <Text
                          style={[
                            {
                              fontSize: helpers.isDesktop() ? 14 : 16,
                              lineHeight: helpers.isDesktop() ? 16 : 23,
                              fontFamily: FontFamily.regular,
                              color: selectedTab ==2 ? '#ffffff':"#7B8FFE",
                            },
                          ]}
                        >
                          Days 8-14{" "}
                        </Text>
                      </TouchableOpacity>
                      <TouchableOpacity
                       onPress={()=>{
                        this.getEditions(
                           moment(new Date()).subtract(28, 'days').format("DD-MM-YYYY"),
                           moment(new Date()).subtract(15, 'days').format("DD-MM-YYYY"),
 
                         );
                         this.setState({selectedTab:3})
 
                       }}
                        style={[
                          Flex.row,
                          Flex.alignCenter,
                          Flex.justfiyCenter,
                          {
                            marginRight: 10,
                            marginBottom: 15,
                            width: helpers.isDesktop() ? 93 : 111,
                          },
                          {
                            padding: 8,
                            borderRadius: 20,
                            borderColor: "#7B8FFE",
                            background: selectedTab ==3 ? "#7B8FFE":'#ffffff',
                            borderWidth: 2,
                          },
                        ]}
                      >
                        <Text
                          style={[
                            {
                              fontSize: helpers.isDesktop() ? 14 : 16,
                              lineHeight: helpers.isDesktop() ? 16 : 23,
                              fontFamily: FontFamily.regular,
                              color: selectedTab ==3 ? '#ffffff':"#7B8FFE",
                            },
                          ]}
                        >
                          Days 15-21
                        </Text>
                      </TouchableOpacity>
                      <TouchableOpacity
                       onPress={()=>{
                        this.getEditions(
                          moment(new Date()).subtract(30, 'days').format("DD-MM-YYYY"),
                          moment(new Date()).subtract(21, 'days').format("DD-MM-YYYY"),
 
                         );
                         this.setState({selectedTab:4})
                       }}
                        style={[
                          Flex.row,
                          Flex.alignCenter,
                          Flex.justfiyCenter,
                          {
                            marginRight: 10,
                            marginBottom: 15,
                            width: helpers.isDesktop() ? 93 : 111,
                          },
                          {
                            padding: 8,
                            borderRadius: 20,
                            borderColor: "#7B8FFE",
                            background: selectedTab ==4 ? "#7B8FFE":'#ffffff',
                            borderWidth: 2,
                          },
                        ]}
                      >
                        <Text
                          style={[
                            {
                              fontSize: helpers.isDesktop() ? 14 : 16,
                              lineHeight: helpers.isDesktop() ? 16 : 23,
                              fontFamily: FontFamily.regular,
                              color: selectedTab ==4 ? '#ffffff':"#7B8FFE",
                            },
                          ]}
                        >
                          Days 21-30
                        </Text>
                      </TouchableOpacity>
                    </View>
                  </ScrollView>
                </SafeAreaView>
              </View>
              {/* for bad api resposne */}
              {storyDataLastWeek ===false && 
              <View style={{ marginLeft: 'auto', marginRight: 'auto', marginTop: 50 }}>
                <Text style={{ fontWeight: "700", fontSize: 22, color: '#6C7AF6' }}> 
                  Please select a valid date range
                </Text>
              </View>
              }
              {storyDataLastWeek && storyDataLastWeek.map((item,index)=>{
                return(
              <View
                style={[
                  { backgroundColor: isUserLoggedIn ? "white" : "#F3F5FF" },
                  !isUserLoggedIn && {
                    marginBottom: 30,
                    borderLeftWidth: 8,
                    borderColor: "#ECB731",
                  },
                  { marginBottom: 20, padding: helpers.isDesktop() ? 20 : 10 },
                  darkMode && { backgroundColor: Colors.darkPurple },
                ]}
              >
                <TouchableOpacity
                    onPress={() =>
                      this.props.history.push({
                        pathname: `/yesterday/${item.slug}`,
                        state: item
                      })
                    }>
                <Text
                  style={[
                    {
                      fontSize: helpers.isDesktop() ? 18 : 16,
                      lineHeight: helpers.isDesktop() ? 26 : 23,
                      fontFamily: FontFamily.bold,
                      color: "#051462",
                    },
                    { textAlign: "left", marginBottom: 15 },
                    darkMode && { color: "rgba(255, 255, 255, 0.89)" },
                  ]}
                >
                  {moment(item?.published_date).format('DD MMMM YYYY')}
                </Text>
                </TouchableOpacity>
                {item.posts.map((value,idx)=>{
                  return(
                    <TouchableOpacity
                    onPress={() =>
                      this.props.history.push({
                        pathname: `/yesterday/${item.slug}`,
                        state: item
                      })
                    }>
                <View
                  style={[
                    isUserLoggedIn && {
                      marginBottom: 15,
                      borderLeftWidth: 4,
                      borderColor: this.renderBorderColor(value?.category[0]),
                      paddingLeft: 10,
                    },
                  ]}
                >
                  <Text
                    style={[
                      {
                        fontSize: helpers.isDesktop() ? 18 : 16,
                        lineHeight: helpers.isDesktop() ? 26 : 23,
                        fontFamily: FontFamily.regular,
                        color: "#051462",
                      },
                      { textAlign: "left" },
                      darkMode && { color: "rgba(255, 255, 255, 0.89)" },
                    ]}
                  >
                    {value.title}
                  </Text>
                </View> 
                </TouchableOpacity>
                )
                })}
                {/* <View
                  style={[
                    isUserLoggedIn && {
                      marginBottom: 15,
                      borderLeftWidth: 4,
                      borderColor: "#F7A34B",
                      paddingLeft: 10,
                    },
                  ]}
                >
                  <Text
                    style={[
                      {
                        fontSize: helpers.isDesktop() ? 18 : 16,
                        lineHeight: helpers.isDesktop() ? 26 : 23,
                        fontFamily: FontFamily.regular,
                        color: "#051462",
                      },
                      { textAlign: "left" },
                      darkMode && { color: "rgba(255, 255, 255, 0.89)" },
                    ]}
                  >
                    Mumbai saw its first Delta COVID-19 variant death; a fully
                    vaccinated woman died
                  </Text>
                </View>
                <View
                  style={[
                    isUserLoggedIn && {
                      marginBottom: 15,
                      borderLeftWidth: 4,
                      borderColor: "#DE0046",
                      paddingLeft: 10,
                    },
                  ]}
                >
                  <Text
                    style={[
                      {
                        fontSize: helpers.isDesktop() ? 18 : 16,
                        lineHeight: helpers.isDesktop() ? 26 : 23,
                        fontFamily: FontFamily.regular,
                        color: "#051462",
                      },
                      { textAlign: "left" },
                      darkMode && { color: "rgba(255, 255, 255, 0.89)" },
                    ]}
                  >
                    Mumbai saw its first Delta COVID-19 variant death; a fully
                    vaccinated woman died
                  </Text>
                </View>
                <View
                  style={[
                    isUserLoggedIn && {
                      marginBottom: 15,
                      borderLeftWidth: 4,
                      borderColor: "#A97DF1",
                      paddingLeft: 10,
                    },
                  ]}
                >
                  <Text
                    style={[
                      {
                        fontSize: helpers.isDesktop() ? 18 : 16,
                        lineHeight: helpers.isDesktop() ? 26 : 23,
                        fontFamily: FontFamily.regular,
                        color: "#051462",
                      },
                      { textAlign: "left" },
                      darkMode && { color: "rgba(255, 255, 255, 0.89)" },
                    ]}
                  >
                    Mumbai saw its first Delta COVID-19 variant death; a fully
                    vaccinated woman died
                  </Text>
                </View>
                <View
                  style={[
                    isUserLoggedIn && {
                      marginBottom: 15,
                      borderLeftWidth: 4,
                      borderColor: "#ECB731",
                      paddingLeft: 10,
                    },
                  ]}
                >
                  <Text
                    style={[
                      {
                        fontSize: helpers.isDesktop() ? 18 : 16,
                        lineHeight: helpers.isDesktop() ? 26 : 23,
                        fontFamily: FontFamily.regular,
                        color: "#051462",
                      },
                      { textAlign: "left" },
                      darkMode && { color: "rgba(255, 255, 255, 0.89)" },
                    ]}
                  >
                    Mumbai saw its first Delta COVID-19 variant death; a fully
                    vaccinated woman died
                  </Text>
                </View> */}
              </View>
              )
            })}

              
              {/* <View
                style={[
                  { backgroundColor: isUserLoggedIn ? "white" : "#F3F5FF" },
                  !isUserLoggedIn && {
                    marginBottom: 30,
                    borderLeftWidth: 8,
                    borderColor: "#ECB731",
                  },
                  { marginBottom: 20, padding: helpers.isDesktop() ? 20 : 10 },
                  darkMode && { backgroundColor: Colors.darkPurple },
                ]}
              >
                <Text
                  style={[
                    {
                      fontSize: helpers.isDesktop() ? 18 : 16,
                      lineHeight: helpers.isDesktop() ? 26 : 23,
                      fontFamily: FontFamily.bold,
                      color: "#051462",
                    },
                    { textAlign: "left", marginBottom: 15 },
                    darkMode && { color: "rgba(255, 255, 255, 0.89)" },
                  ]}
                >
                  23 August, 2021
                </Text>
                <View
                  style={[
                    isUserLoggedIn && {
                      marginBottom: 15,
                      borderLeftWidth: 4,
                      borderColor: "#6C7AF6",
                      paddingLeft: 10,
                    },
                  ]}
                >
                  <Text
                    style={[
                      {
                        fontSize: helpers.isDesktop() ? 18 : 16,
                        lineHeight: helpers.isDesktop() ? 26 : 23,
                        fontFamily: FontFamily.regular,
                        color: "#051462",
                      },
                      { textAlign: "left" },
                      darkMode && { color: "rgba(255, 255, 255, 0.89)" },
                    ]}
                  >
                    Mumbai saw its first Delta COVID-19 variant death; a fully
                    vaccinated woman died
                  </Text>
                </View>
                <View
                  style={[
                    isUserLoggedIn && {
                      marginBottom: 15,
                      borderLeftWidth: 4,
                      borderColor: "#F7A34B",
                      paddingLeft: 10,
                    },
                  ]}
                >
                  <Text
                    style={[
                      {
                        fontSize: helpers.isDesktop() ? 18 : 16,
                        lineHeight: helpers.isDesktop() ? 26 : 23,
                        fontFamily: FontFamily.regular,
                        color: "#051462",
                      },
                      { textAlign: "left" },
                      darkMode && { color: "rgba(255, 255, 255, 0.89)" },
                    ]}
                  >
                    Mumbai saw its first Delta COVID-19 variant death; a fully
                    vaccinated woman died
                  </Text>
                </View>
                <View
                  style={[
                    isUserLoggedIn && {
                      marginBottom: 15,
                      borderLeftWidth: 4,
                      borderColor: "#DE0046",
                      paddingLeft: 10,
                    },
                  ]}
                >
                  <Text
                    style={[
                      {
                        fontSize: helpers.isDesktop() ? 18 : 16,
                        lineHeight: helpers.isDesktop() ? 26 : 23,
                        fontFamily: FontFamily.regular,
                        color: "#051462",
                      },
                      { textAlign: "left" },
                      darkMode && { color: "rgba(255, 255, 255, 0.89)" },
                    ]}
                  >
                    Mumbai saw its first Delta COVID-19 variant death; a fully
                    vaccinated woman died
                  </Text>
                </View>
                <View
                  style={[
                    isUserLoggedIn && {
                      marginBottom: 15,
                      borderLeftWidth: 4,
                      borderColor: "#A97DF1",
                      paddingLeft: 10,
                    },
                  ]}
                >
                  <Text
                    style={[
                      {
                        fontSize: helpers.isDesktop() ? 18 : 16,
                        lineHeight: helpers.isDesktop() ? 26 : 23,
                        fontFamily: FontFamily.regular,
                        color: "#051462",
                      },
                      { textAlign: "left" },
                      darkMode && { color: "rgba(255, 255, 255, 0.89)" },
                    ]}
                  >
                    Mumbai saw its first Delta COVID-19 variant death; a fully
                    vaccinated woman died
                  </Text>
                </View>
                <View
                  style={[
                    isUserLoggedIn && {
                      marginBottom: 15,
                      borderLeftWidth: 4,
                      borderColor: "#ECB731",
                      paddingLeft: 10,
                    },
                  ]}
                >
                  <Text
                    style={[
                      {
                        fontSize: helpers.isDesktop() ? 18 : 16,
                        lineHeight: helpers.isDesktop() ? 26 : 23,
                        fontFamily: FontFamily.regular,
                        color: "#051462",
                      },
                      { textAlign: "left" },
                      darkMode && { color: "rgba(255, 255, 255, 0.89)" },
                    ]}
                  >
                    Mumbai saw its first Delta COVID-19 variant death; a fully
                    vaccinated woman died
                  </Text>
                </View>
              </View> */}
              {/* <TouchableOpacity
                style={[
                  Flex.row,
                  Flex.alignCenter,
                  Flex.justfiyCenter,
                  !helpers.isDesktop() && { width: "100%" },
                  {
                    padding: 30,
                    paddingLeft: helpers.isDesktop() ? 30 : 0,
                    paddingRight: helpers.isDesktop() ? 30 : 0,
                  },
                ]}
              >
                <Text
                  style={[
                    {
                      fontSize: helpers.isDesktop() ? 20 : 16,
                      lineHeight: helpers.isDesktop() ? 24 : 23,
                      fontFamily: FontFamily.regular,
                      color: "#907CFF",
                      textTransform: "uppercase",
                      padding: 12,
                      paddingLeft: 20,
                      paddingRight: 20,
                      borderRadius: 4,
                      borderColor: "#907CFF",
                      borderWidth: 2,
                      width: helpers.isDesktop() ? "auto" : "100%",
                      textAlign: "center",
                    },
                  ]}
                >
                  show more
                </Text>
              </TouchableOpacity> */}
            </View>
          )}
        </View>
      </View>
    );
  };

  renderPageContent = () => {
    let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);
    return (
      <>
        {!this.state.isUserLoggedIn ? (
          <>
            <YesterdayStoryBanner />

            {/* yesterday -api block */}

            {this.YesterdayData(darkMode)}

            {/* Start : why yesterday block */}
            <View
              style={[
                { background: "#F3F5FF" },
                {
                  padding: helpers.isDesktop() ? 40 : 16,
                  paddingTop: helpers.isDesktop() ? 40 : 20,
                  paddingBottom: helpers.isDesktop() ? 0 : 20,
                },
                darkMode && { backgroundColor: Colors.darkPurple },
              ]}
            >
              <View
                style={[
                  helpers.isDesktop() ? Flex.row : Flex.column,
                  //   Flex.alignCenter,
                  { alignItems: "space-between" },
                  Flex.justfiyCenter,
                  {
                    maxWidth: helpers.isDesktop() ? "95%" : "100%",
                    width: "100%",
                    margin: "auto",
                  },
                ]}
              >
                <View
                  style={[
                    {
                      width: helpers.isDesktop() ? "48%" : "100%",
                      paddingVertical: helpers.isDesktop() ? 0 : 40,
                      //   padding: 10,
                    },
                  ]}
                >
                  <Text
                    style={[
                      {
                        fontSize: helpers.isDesktop() ? 60 : 27,
                        lineHeight: helpers.isDesktop() ? 80 : 35,
                        fontFamily: FontFamily.abrilFatface,
                        marginTop: helpers.isDesktop() ? 70 : 0,
                        color: "#051462",
                      },
                      {
                        paddingBottom: 3,
                        textAlign: "left",
                      },
                      darkMode && { color: "rgba(255, 255, 255, 0.89)" },
                    ]}
                  >
                    Why YESTERDAY?
                  </Text>
                  <Text
                    style={[
                      {
                        fontSize: helpers.isDesktop() ? 24 : 16,
                        lineHeight: helpers.isDesktop() ? 36 : 23.5,
                        fontFamily: FontFamily.regular,
                        color: "#051462",
                      },
                      {
                        textAlign: "left",
                        marginTop: helpers.isDesktop() ? 34 : 10,
                        marginBottom: helpers.isDesktop() ? 0 : 10,
                      },
                      darkMode && { color: "rgba(255, 255, 255, 0.89)" },
                    ]}
                  >
                    Don’t scroll anymore, let Yesterday
                    {helpers.isDesktop() ? " " : "\n"}bring the news to you
                  </Text>
                </View>
                <View
                  style={[
                    {
                      width: helpers.isDesktop() ? "52%" : "115%",
                    },
                    !helpers.isDesktop() && { alignSelf: "center" },
                  ]}
                >
                  <CustomImage
                    source={
                      helpers.isDesktop()
                        ? yesterdayImageDesktop3
                        : yesterdayImageMobile3
                    }
                    require={true}
                    style={[
                      helpers.isWeb()
                        ? { width: "100%", height: "auto" }
                        : { height: 400, width: "100%" },
                    ]}
                    webStyle={{
                      width: helpers.isDesktop() ? "100%" : "100%",
                      height: helpers.isDesktop() ? 400 : "100%",
                    }}
                    altText={"The Morning Context"}
                    resizeMode={"contain"}
                  />
                </View>
              </View>
            </View>
            {/* End */}

            {/* Start: read smarter Block */}
            <View
              style={[
                { background: "#ffffff" },
                {
                  padding: helpers.isDesktop() ? 60 : 0,
                  paddingTop: helpers.isDesktop() ? 60 : 0,
                  paddingBottom: helpers.isDesktop() ? 60 : 0,
                },
                darkMode && { backgroundColor: Colors.darkPurple },
              ]}
            >
              <ImageBackground
                style={[
                  helpers.isDesktop() ? Flex.row : Flex.column,
                  helpers.isDesktop() ? Flex.alignCenter : Flex.alignStart,
                  Flex.justfiyCenter,
                  {
                    maxWidth: helpers.isDesktop() ? "90%" : "100%",
                    width: "100%",
                    margin: "auto",
                    background: "#ccc",
                  },
                ]}
                source={accountContentBoxbg}
                resizeMode="cover"
              >
                <View
                  style={[
                    {
                      width: helpers.isDesktop() ? "35%" : "100%",
                      padding: helpers.isDesktop() ? 15 : 30,
                      paddingTop: helpers.isDesktop() ? 15 : 40,
                    },
                  ]}
                >
                  <View style={[!helpers.isDesktop() && { width: 100 }]}>
                    <CustomImage
                      source={
                        helpers.isDesktop()
                          ? NotificationsFlatline
                          : notificationsFlatlineMobile
                      }
                      require={true}
                      style={[
                        helpers.isWeb()
                          ? { width: "100%", height: "auto" }
                          : { width: 100, height: 150 },
                      ]}
                      altText={"The Morning Context"}
                      resizeMode={"contain"}
                    />
                  </View>
                </View>
                <View
                  style={[
                    {
                      width: helpers.isDesktop() ? "50%" : "100%",
                      padding: helpers.isDesktop() ? 15 : 16,
                    },
                  ]}
                >
                  <Text
                    style={[
                      {
                        fontSize: helpers.isDesktop() ? 72 : 32,
                        lineHeight: helpers.isDesktop() ? 86 : 38.4,
                        fontFamily: FontFamily.abrilFatface,
                        color: "#ffffff",
                      },
                      { textAlign: "left" },
                    ]}
                  >
                    Read Smarter
                  </Text>
                  <Text
                    style={[
                      {
                        fontSize: helpers.isDesktop() ? 24 : 16,
                        lineHeight: helpers.isDesktop() ? 36 : 24,
                        fontFamily: FontFamily.light,
                        color: "#ffffff",
                      },
                      {
                        textAlign: "left",
                        marginTop: 10,
                        marginBottom: helpers.isDesktop() ? 20 : 15,
                      },
                    ]}
                  >
                    Sign up for Yesterday and let it help you
                    {helpers.isDesktop() ? " " : "\n"}catch up with the news
                  </Text>
                  <View
                    style={[
                      helpers.isDesktop() ? Flex.row : Flex.column,
                      Flex.alignCenter,
                      { width: "100%" },
                      !helpers.isDesktop() && { paddingVertical: 40 },
                    ]}
                  >
                    <TouchableOpacity
                      onPress={() =>
                        this.props.navigateToScreen("/sign-up?redirect=/&")
                      }
                      style={[
                        Flex.row,
                        Flex.alignCenter,
                        Flex.justfiyCenter,
                        !helpers.isDesktop() && { width: "100%" },
                      ]}
                    >
                      <Text
                        style={[
                          {
                            backgroundColor: "rgb(255, 255, 255)",
                            borderColor: "#FFFFFF",
                            borderWidth: 1,
                            borderRadius: 4,
                            height: 56,
                            padding: 15,
                            fontFamily: FontFamily.medium,
                            fontSize: helpers.isDesktop() ? 20 : 16,
                            lineHeight: helpers.isDesktop() ? 24 : 24,
                            color: "#051462",
                            textAlign: "center",
                          },
                          !helpers.isDesktop() && { width: "100%" },
                        ]}
                      >
                        {" "}
                        SIGN UP
                      </Text>
                    </TouchableOpacity>
                  </View>
                </View>
              </ImageBackground>
            </View>
            {/* End */}
          </>
        ) : (
          <>
            {/* yesterday -api block */}
            {this.YesterdayData(darkMode)}
          </>
        )}
      </>
    );
  };

  renderWebPage = () => {
    return (
      <>
        {this.renderPageHeader()}
        {this.renderPageContent()}
      </>
    );
  };

  renderAppPage = () => {
    const { pageLoader, showErrorModal, showUparrow, footerData } = this.state;
    return (
      <ScrollView>
        {this.renderPageHeader()}
        {this.renderPageContent()}
        <AppFooter
          navigateWeb={(slug) => this.props.navigateToScreen(slug)}
          navigateApp={(slug, params) =>
            this.props.navigation.navigate(slug, params)
          }
          footerData={footerData}
          Breadcrumbs={Breadcrumbs}
        />
      </ScrollView>
    );
  };

  render() {
    const { pageLoader, showErrorModal, showUparrow, footerData } = this.state;
    let {archiveSlug} = this.props
    const webView = helpers.isWeb();
    let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);
    let redirectSlugs = {
      web: "/",
      native: { redirect: "/", verifyRedirect: "/" },
    };
    return (
      <React.Suspense fallback={null}>
        <View
          style={[
            webView && { paddingTop: helpers.isDesktop() ? 54 : 56 },
            appStyles.appBg,
            Flex.fill,
            darkMode && { backgroundColor: Colors.darkBlackColorBg },
          ]}
        >
          {/* header : we will be new component for this module */}
          {/* <Seo data={this.getSeoObject()} page={this.getSeoPage()} pageData={{ pageTitle: this.getPageTitle(), pageSlug: archiveSlug }} /> */}
            <Seo data={seoObj['yesterday']} url={process.browser ? window.location.origin + window.location.pathname : ''} page="/yesterday" />
          <AppHeader
            ref="header"
            history={this.props.history}
            searchQuery={this.props.searchQuery}
            locationHash={this.props.locationHash}
            navigateWeb={(slug) => this.props.navigateToScreen(slug)}
            navigateApp={(slug, params) =>
              this.props.navigation.navigate(slug, params)
            }
            redirectSlugs={redirectSlugs}
            refreshPage={() =>
              this.setState({ subscriptionRefreshKey: !subscriptionRefreshKey })
            }
            setCredits={(credits) => this.setState({ credits: credits })}
            navigateToSubscriptionScreen
            darkMode={darkMode}
            showFullHeader={true}
          />
          {!showErrorModal && (
            <>
              {pageLoader
                ? this.showPageLoader()
                : webView
                ? this.renderWebPage()
                : this.renderAppPage()}
            </>
          )}
          <AppFooter
            navigateWeb={(slug) => this.props.navigateToScreen(slug)}
            navigateApp={(slug, params) =>
              this.props.navigation.navigate(slug, params)
            }
            footerData={footerData}
            Breadcrumbs={Breadcrumbs}
          />

          {showErrorModal && (
            <ErrorModal
              goToHome={() => this.props.navigateToScreen("/")}
              tryAgain={() => this.getModalClickEvent()}
              show={showErrorModal}
            />
          )}
        </View>
      </React.Suspense>
    );
  }
}

const mapStateToProps = (state) => {
  const { app, user } = state;
  return { app, user };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ removeUserToken }, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AuthenticationWrapper(Yesterday));

let Breadcrumbs = [
  {
    name: "Home",
    link: "/",
  },
  {
    name: "Yesterday",
  },
];

const customStyle = StyleSheet.create({
  container: {
    flex: 1,
    paddingTop: StatusBar.currentHeight,
  },
  scrollView: {},
  text: {
    fontSize: 42,
  },
});

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    marginTop: 20,
    marginBottom: 20
  },
  activityIndicator: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    height: 80
 }
});